import { OnDestroy, OnInit }     from "@angular/core";
import { AppStatus, DoorStates } from "../../@models/app-status";
import { StatusListener }        from "../../status-listener";
import { Problem }               from "../../../shared-gen/Machine/Problem";
import { VmcState }              from "../../../shared-gen/Vending/Status/VmcState";
import { AppStatusFun }          from "../../@models/app-status.fun";
import { OrderItemStatus }       from "../../../shared-gen/Model/Orders/OrderItemStatus";
import { AppService }            from "../../services/app.service";
import { DoorState }             from "../../../shared-gen/Model/Devices/DoorState";

export class WarningPageBase extends StatusListener implements OnInit, OnDestroy {

	problems: Problem[] = [];
	vmcState = VmcState.Intervention;
	message: string = null;
	doors: DoorStates = {};
	isFailedCompletely = false;

	constructor(app: AppService, onStatusChanged?: (AppStatus) => void) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);

		const ms = status.deviceStatus.MachineStatus;
		this.vmcState = AppStatusFun.getVmcState(status);
		this.problems = ms.Problems;
		this.message = ms.Message;
		this.doors = status.deviceStatus.Doors;
		const lastFinishedOrder = status.deviceStatus.VendingStatus.LastFinishedOrder;
		if (this.vmcState === VmcState.Failed && lastFinishedOrder != null) {
			// Order failed completely (all items failed) or just in parts?
			this.isFailedCompletely = lastFinishedOrder.Items.every(
				it => it.Status === OrderItemStatus.Failed);
		}
	}

	isDoorOpen() {
		return this.doors["MachineDoor"] == DoorState.Opened ||
			this.doors["FridgeDoor"] == DoorState.Opened;
	}

	getOpenDoorsText(): string {
		const m = this.doors["MachineDoor"] == DoorState.Opened;
		const f = this.doors["FridgeDoor"] == DoorState.Opened;
		if (m && f) {
			return this.translate("🌐General.Warning.OpenDoors.Both");
		} else if (m) {
			return this.translate("🌐General.Warning.OpenDoors.Above");
		} else if (f) {
			return this.translate("🌐General.Warning.OpenDoors.Below");
		} else {
			return "?";
		}
	}
}
